import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';

import { GroupDownloadFile } from '@keaze/web/components/groupDownloadFile';
import { StartRegistration } from '../startRegistration';

export const FiltersContainer = styled(Grid)`
  ${({ theme: { breakpoints } }) => `
    flex-direction: column-reverse;

    ${breakpoints.up('md')} {
      flex-direction: row;
    }
  `}
`;

export const ItemStartRegistration = styled(Grid)`
  ${({ theme: { breakpoints } }) => `
    display: none;

    ${breakpoints.up('md')} {
      display: block;
    }
  `}
`;

export const MobileStartRegistration = styled(StartRegistration)`
  ${({ theme: { breakpoints } }) => `
      display: block;
    ${breakpoints.up('lg')} {
      display: none;
    }
  `}
`;

export const StyledGroupDownloadFile = styled(GroupDownloadFile)`
  margin-bottom: 24px;
`;
